import GenericRequest, { METHOD_POST } from '../../shared/webservices/GenericRequest';
import { ApiEndpoints } from '../../shared/webservices/endpoint';

export default class UploadRequest extends GenericRequest {

    constructor(file) {
        super(METHOD_POST, ApiEndpoints.UPLOAD);
        this.removeHeader('Content-Type');
        this.file = file;
    }

    overrideRequest() {
        const data = new FormData();
        data.append('file', this.file);
        return data;
    }

}



// WEBPACK FOOTER //
// ./src/app/profile/ws/UploadRequest.js